import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { DateTime } from 'luxon';
import range from 'lodash.range';

import Button from '../Button';
import AngleLeftIcon from '../../icons/AngleLeftIcon';
import { getAsset } from '../../../util/assets';
import AngleRightIcon from '../../icons/AngleRightIcon';

const propTypes = {
  onChange: PropTypes.func,
  selected: PropTypes.date,
};

const DatePickerWithYearDropdown = ({ onChange, selected, ...props }) => {
  // Results in Current year + 2
  const years = range(1920, DateTime.now().get('year') + 3, 1);
  const months = [
    { label: 'Jan', value: 0 },
    { label: 'Feb', value: 1 },
    { label: 'Mar', value: 2 },
    { label: 'Apr', value: 3 },
    { label: 'May', value: 4 },
    { label: 'Jun', value: 5 },
    { label: 'Jul', value: 6 },
    { label: 'Aug', value: 7 },
    { label: 'Sep', value: 8 },
    { label: 'Oct', value: 9 },
    { label: 'Nov', value: 10 },
    { label: 'Dec', value: 11 },
  ];

  return (
    <DatePicker
      renderCustomHeader={({
        date: currentDate,
        decreaseMonth,
        increaseMonth,
        changeMonth,
        changeYear,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => {
        const date = DateTime.fromJSDate(currentDate);
        const selectedDate = selected ? DateTime.fromJSDate(selected) : null;
        const { month, year } = date;
        const { month: selectedMonth } = selectedDate ?? {};

        return (
          <div className="d-flex justify-content-between align-items-center p-2">
            <Button
              btnStyle="link"
              disabled={prevMonthButtonDisabled}
              onClick={decreaseMonth}
            >
              <AngleLeftIcon height={16} color="#0d84fe" />
            </Button>
            <div className="text-extra-bold text-sm d-flex align-items-center">
              <img
                src={getAsset('/schedule-illustration.png')}
                className="mr-2"
                alt="Schedule"
                height="32px"
              />
              <div className="d-flex">
                <select
                  value={month - 1}
                  className="react-datepicker-custom-month-select"
                  onChange={({ target: { value } }) => {
                    changeMonth(value);
                  }}
                >
                  {months.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <select
                  value={year}
                  className="react-datepicker-custom-year-select"
                  onChange={({ target: { value } }) => {
                    changeYear(value);
                    if (selectedDate) {
                      onChange(
                        date
                          .set({ month: selectedMonth, year: value })
                          .toJSDate(),
                      );
                    }
                  }}
                >
                  {years.map(option => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <Button
              btnStyle="link"
              disabled={nextMonthButtonDisabled}
              onClick={increaseMonth}
            >
              <AngleRightIcon height={16} color="#0d84fe" />
            </Button>
          </div>
        );
      }}
      onChange={onChange}
      selected={selected}
      {...props}
    />
  );
};

DatePickerWithYearDropdown.propTypes = propTypes;

export default DatePickerWithYearDropdown;
